import axios from 'axios'
import React, { useState } from 'react'
import authService from '../../../../Components/Login/auth.service'
import '../../../../styles/pages/SubMenuPages/SubMenuGruposUsuarios/pagesGruposDeUsuario/modalNovoGrupoUser.css'

export default function Modal({ setOpenModal, modalInfo }) {
  var user = authService.getCurrentUser()
  let newDate = new Date()

  const [campos, setCampos] = useState({
    IdGrupoUsuario: modalInfo.IdGrupoUsuario,
    IdEmpresa: modalInfo.IdEmpresa,
    gruDescricao: modalInfo.gruDescricao,
    gruObservacoes: modalInfo.gruObservacoes,
    gruStatus: modalInfo.gruStatus,
    gruAlteradoPor: user[0].pesEmail,
    gruAlteradoEm: newDate
  })
  function handleInputChange(event) {
    campos[event.target.name] = event.target.value
    setCampos(campos)
  }

  function handleFormSubmit(event) {
    event.preventDefault()
    axios
      .put(
        process.env.REACT_APP_API_URL +
          '/api/v1/grupousuario/' +
          modalInfo.IdGrupoUsuario,
        campos
      )
      .then(response => {
        alert(response.data.message)
        window.location.reload()
      })
  }

  return (
    <div className="ModalNovoGrupoUser">
      <div
        onClick={() => {
          setOpenModal(false)
        }}
        className="overlay"
      ></div>
      <div className="modalPadrao-content">
        <div className="cxTituloPadrao">
          <h1>
            Editar Grupo de Usuários
            <hr className="hrTitleModal" />
          </h1>
          <button
            className="close-modal"
            onClick={() => {
              setOpenModal(false)
            }}
          >
            X
          </button>
        </div>

        <form onSubmit={handleFormSubmit}>
          <label>Novo Grupo:</label>
          <input
            type="text"
            id="fname"
            defaultValue={campos.gruDescricao}
            name="gruDescricao"
            onChange={handleInputChange}
          ></input>
          <label>Observações:</label>
          <textarea
            type="text"
            id="fname"
            defaultValue={campos.gruObservacoes}
            name="gruObservacoes"
            onChange={handleInputChange}
            row="none"
            maxLength="500"
          ></textarea>
          <div className="caixaSalvarPadrao">
            <button type="submit">Salvar Registro</button>
          </div>
        </form>
      </div>
    </div>
  )
}
